var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2498 15.8875C13.1327 15.7713 13.0397 15.6331 12.9762 15.4807C12.9127 15.3284 12.8801 15.165 12.8801 15C12.8801 14.835 12.9127 14.6716 12.9762 14.5193C13.0397 14.367 13.1327 14.2287 13.2498 14.1125L18.9873 8.38751C19.1045 8.27131 19.1975 8.13306 19.2609 7.98074C19.3244 7.82841 19.3571 7.66503 19.3571 7.50001C19.3571 7.335 19.3244 7.17162 19.2609 7.01929C19.1975 6.86697 19.1045 6.72872 18.9873 6.61251C18.7531 6.3797 18.4363 6.24902 18.1061 6.24902C17.7758 6.24902 17.459 6.3797 17.2248 6.61251L11.4873 12.35C10.7851 13.0531 10.3906 14.0063 10.3906 15C10.3906 15.9938 10.7851 16.9469 11.4873 17.65L17.2248 23.3875C17.4577 23.6184 17.7719 23.7486 18.0998 23.75C18.2643 23.751 18.4274 23.7194 18.5797 23.6572C18.732 23.595 18.8705 23.5034 18.9873 23.3875C19.1045 23.2713 19.1975 23.1331 19.2609 22.9807C19.3244 22.8284 19.3571 22.665 19.3571 22.5C19.3571 22.335 19.3244 22.1716 19.2609 22.0193C19.1975 21.867 19.1045 21.7287 18.9873 21.6125L13.2498 15.8875Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmall);
export default __webpack_public_path__ + "static/media/ArrowSmall.740139098551855c66ee6b048e7ad142.svg";
export { ForwardRef as ReactComponent };